import * as Font from 'expo-font';
import { useEffect, useState } from 'react';

const CUSTOM_FONTS = {
	dq: require('../assets/fonts/GD-DOTFONT-DQ-OTF_008.otf'),
} as const;

type FontFamily = keyof typeof CUSTOM_FONTS;

export const getFontFamily = (family: FontFamily): FontFamily => {
	return family;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useFonts = () => {
	const [fontsLoaded, setFontsLoaded] = useState(false);

	const _loadFontsAsync = async () => {
		await Font.loadAsync(CUSTOM_FONTS);
		setFontsLoaded(true);
	};
	useEffect(() => {
		_loadFontsAsync();
	}, []);

	return { fontsLoaded };
};

export default useFonts;
